import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { copyToClipboard, shareContent } from '../../utils/clipboard';
import { useToast } from '../../contexts/ToastContext';
import './CalendarModal.css';

export default function CalendarSuccessModal({ calendar, onClose }) {
  const [copiedCode, setCopiedCode] = useState(false);
  const [shared, setShared] = useState(false);
  const navigate = useNavigate();
  const { showToast } = useToast();

  const shareLink = `${window.location.origin}/calendar/${calendar.id}`;

  async function handleShare() {
    const result = await shareContent({
      title: calendar.name,
      text: `انضم إلى مجموعة "${calendar.name}"`,
      url: shareLink,
    });
    if (result.success) {
      if (result.method === 'copy') {
        setShared(true);
        setTimeout(() => setShared(false), 2000);
      }
    }
  }

  async function copyInviteCode() {
    const success = await copyToClipboard(calendar.inviteCode);
    if (success) {
      setCopiedCode(true);
      setTimeout(() => setCopiedCode(false), 2000);
    } else {
      showToast('فشل النسخ. حاول مرة أخرى.', 'error');
    }
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content success-modal" onClick={(e) => e.stopPropagation()}>
        <div className="success-icon">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22 4 12 14.01 9 11.01"></polyline>
          </svg>
        </div>

        <h2>تم إنشاء المجموعة بنجاح! 🎉</h2>
        <p className="success-description">
          تم إنشاء "{calendar.name}" بنجاح. شارك الرابط أو رمز الدعوة مع الأعضاء للانضمام.
        </p>

        <button className="btn-share-link" onClick={handleShare}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="18" cy="5" r="3"></circle>
            <circle cx="6" cy="12" r="3"></circle>
            <circle cx="18" cy="19" r="3"></circle>
            <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
            <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
          </svg>
          مشاركة الرابط
        </button>
        {shared && <span className="copied-message">تم نسخ الرابط! ✓</span>}

        <div className="invite-code-section">
          <label>رمز الدعوة</label>
          <div className="code-display">
            <span className="invite-code">{calendar.inviteCode}</span>
            <button
              className="copy-btn"
              onClick={copyInviteCode}
              title="نسخ الرمز"
            >
              {copiedCode ? (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              ) : (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                </svg>
              )}
            </button>
          </div>
          {copiedCode && <span className="copied-message">تم النسخ! ✓</span>}
        </div>

        <div className="info-hint">
          <div className="info-hint-icon" tabIndex="0">
            i
            <div className="info-hint-message">
              <p>يمكن للأعضاء استخدام الرابط للدخول مباشرة أو رمز الدعوة للانضمام من خلال خيار "الانضمام لمجموعة"</p>
            </div>
          </div>
        </div>

        <div className="modal-actions">
          <button className="btn btn-secondary" onClick={onClose}>
            إغلاق
          </button>
          <button
            className="btn btn-primary"
            onClick={() => {
              onClose();
              navigate(`/calendar/${calendar.id}`);
            }}
          >
            دخول المجموعة ←
          </button>
        </div>
      </div>
    </div>
  );
}